// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { ROUTE_DEFINITIONS, getPath } from "../../routes/routes";
import React, { useState } from "react";

import AuthenticationCard from "./AuthenticationCard";
import { Link } from "react-router-dom";
import PageContent from "../ui/PageContent";
import { Question } from "../ui/Questionnaire/QuestionnaireTypes";
import QuestionnaireForm from "../ui/Questionnaire/Questionnaire";
import QuestionnaireInput from "components/ui/Questionnaire/QuestionnaireInput";
import { resetPassword } from "store/auth";
import { validateEmail } from "../ui/Questionnaire/validators/QuestionnaireValidators";

export default () => {
  const [error, setError] = useState<string | null>(null);
  const [emailSent, setEmailSent] = useState(false);

  const onSubmit = async (
    event: React.FormEvent,
    questions: { [key: string]: Question }
  ) => {
    event.preventDefault();
    const email = questions.email.value;
    try {
      await resetPassword(email!);
      setEmailSent(true);
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <PageContent>
      <AuthenticationCard title="Recover Password">
        {!emailSent && (
          <React.Fragment>
            <QuestionnaireForm
              onSubmit={onSubmit}
              submitLabel="Submit"
              error={error}
            >
              <QuestionnaireInput
                icon="envelope"
                label="Email"
                mandatory={true}
                name="email"
                placeholder="Enter your email"
                type="email"
                validators={[validateEmail]}
              />
            </QuestionnaireForm>
          </React.Fragment>
        )}
        {emailSent && (
          <div>
            An email has been sent to your inbox with instructions to recover
            your password.
          </div>
        )}
        <div>
          <Link to={getPath(ROUTE_DEFINITIONS.LOGIN)}>Go back to login</Link>
        </div>
      </AuthenticationCard>
    </PageContent>
  );
};
